<template>
  <div class="eligibility" v-if="value">
    <!-- Ambassador: simplified view -->
    <EligibilitySimple v-if="isAmbassador" :value="value" />

    <!-- Other roles: original detailed view -->
    <div v-else>
      <!-- Eligible -->
      <v-alert
        v-if="value.eligible === true && value.updatedAt"
        color="success"
        :value="true"
        :closable="false"
      >
        Last check was run
        {{ new Date(value.updatedAt) | inWords({ addSuffix: true }) }}
        at {{ new Date(value.updatedAt) | date('h:mm a, MMMM do yyyy') }}
        when the candidate met all the requirements.
      </v-alert>

      <!-- Ineligible -->
      <v-alert
        v-if="value.eligible === false && value.updatedAt"
        color="warning"
        class="black--text"
        :value="true"
        :closable="false"
      >
        Last check was run
        {{ new Date(value.updatedAt) | inWords({ addSuffix: true }) }}
        at {{ new Date(value.updatedAt) | date('h:mm a, MMMM do yyyy') }}
        when the candidate did not meet all the requirements.
      </v-alert>

      <!-- Unknown -->
      <v-alert
        v-if="value.eligible === null && value.updatedAt"
        color="secondary"
        class="black--text"
        :value="true"
        :closable="false"
      >
        Last check was run
        {{ new Date(value.updatedAt) | inWords({ addSuffix: true }) }}
        at {{ new Date(value.updatedAt) | date('h:mm a, MMMM do yyyy') }}
        when the candidate was potentially eligible but some requirements could not be evaluated.
      </v-alert>

      <!-- Requirement Group Summaries -->
      <div v-if="value" class="v-table">
        <v-list
          :is="group.type"
          v-for="group in value.requirementGroups"
          :group="group"
          :key="group.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Components
import ExperienceRequirementGroup from '@/components/applications/eligibilities/ExperienceRequirementGroup'
import ProfileQualificationRequirementGroup from '@/components/applications/eligibilities/ProfileQualificationRequirementGroup'
import ProfileRequirementGroup from '@/components/applications/eligibilities/ProfileRequirementGroup'
import EligibilitySimple from '@/components/applications/EligibilitySimple'

// Vue Component
export default {
  props: { value: Object },
  components: {
    EligibilitySimple,
    ExperienceRequirementGroup,
    ProfileQualificationRequirementGroup,
    ProfileRequirementGroup,
  },
  computed: {
    isAmbassador() {
      // Use the auth role getter from Vuex
      return this.$store.getters['auth/user'].role === 'Ambassador'
    },
  },
}
</script>

<style>
.requirement.satisfied {
  color: #12c150;
}
.requirement.failed {
  color: #c43237;
}
</style>
